module.exports = __webpack_public_path__ + "pc/img/img2.f468d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head/img2.png
// module id = F40k
// module chunks = 3